<template>
  <div>
    <file-uploader :compMode="compMode" entite="Partner"></file-uploader>

    <div class="card mb-3">
        <div class="card-header" v-if="!coinvestor" >
            <i class="fa fa-briefcase"></i> 
            <span v-if="compMode == CRUDMODE.CREATE || compMode == CRUDMODE.COPY">{{ $t('partner.create.title') }}</span>
            <span v-if="compMode == CRUDMODE.UPDATE">{{ $t('partner.edit.title') }}</span>
            <span v-if="compMode == CRUDMODE.READ">{{ $t('partner.view.title') }}</span>
        </div>
        <div class="card-header" v-if="coinvestor" >
            <i class="fa fa-briefcase"></i> 
            <span v-if="compMode == CRUDMODE.CREATE || compMode == CRUDMODE.COPY">{{ $t('partner.coinvestor.create.title') }}</span>
            <span v-if="compMode == CRUDMODE.UPDATE">{{ $t('partner.coinvestor.edit.title') }}</span>
            <span v-if="compMode == CRUDMODE.READ">{{ $t('partner.coinvestor.view.title') }}</span>
        </div>
        <div class="card-body">

            <errorMessage v-bind:message="error"></errorMessage>

            <form>
                <photo-uploader :compMode="compMode" entite="Partner" :fileType="fileType_partnerLogo" ref="photoUploader"></photo-uploader>

                <div class="row">
                    <div class="form-group col-md-2">
                        <label for="numberInput">{{ $t('partner.form.id') }}*</label>
                        <input readonly v-model="partner.id" type="text" class="form-control" />
                    </div>

                    <div class="form-group col-md-4">
                        <label for="nameInput">{{ $t('partner.form.name') }}*</label>
                        <input v-model.trim="partner.name" v-validate="'required'" name="name" type="text" class="form-control" 
                           id="nameInput" v-bind:placeholder="$t('partner.form.name')" />
                        <span class="text-danger" v-if="errors.has('name')">{{ errors.first('name') }}</span>
                    </div>

                    <div class="form-group col-md-3" v-if="!coinvestor">
                        <label for="planInput">{{ $t('partner.form.plan') }}*</label>
                        <input type="hidden" name="plan_validate" v-model="plan_validate" v-validate="'required'" />
                        <select v-model="partner.plan" class="form-control" id="planInput" v-bind:placeholder="$t('partner.form.plan')">
                            <option v-for="s in plans" :value="s.item1" :key="s.item1">{{s.item2}}</option>
                        </select>
                        <span class="text-danger" v-if="errors.has('plan_validate')">{{ $t('validations.required') }}.</span>
                    </div>

                    <div class="form-group col-md-3" v-else>
                        <label for="planInput">{{ $t('partner.form.angesQuebecCapital') }}</label>
                        <label class="custom-control custom-checkbox">
                            <input type="checkbox" name="angesQuebecCapital" value="1" class="custom-control-input" id="angesQuebecCapital" v-model="partner.angesQuebecCapital">
                            <span class="custom-control-indicator"></span>
                            <span class="custom-control-label">{{$t("yes")}}</span>
                        </label>
                    </div>

                </div>

                <div class="form-group">
                    <label for="commentsInput">{{ $t('partner.form.comments') }}</label>
                    <textarea v-model.trim="partner.comments" name="comments" type="text" class="form-control" id="commentsInput" 
                        :placeholder="$t('partner.form.comments')" ></textarea>
                </div>

                <address-component  v-bind:address="partner.address" v-if="!coinvestor" :required="!coinvestor"></address-component>

                <div class="row" v-if="!coinvestor" >
                    <div class="form-group col-md-12">
                        <div class="card">
                            <div class="card-header">{{ $t('partner.form.implication.title') }}</div>
                            <div class="card-body">

                                <div class="row">
                                    
                                    <div class="form-group col-md-3">
                                        <label for="adhesionInput">{{ $t('partner.form.implication.adhesion') }}</label>
                                        <moment-date-picker v-model="partner.adhesion" :required="false"></moment-date-picker>
                                    </div>

                                    <div class="form-group col-md-3">
                                        <label for="annulationInput">{{ $t('partner.form.implication.annulation') }}</label>
                                        <moment-date-picker v-model="partner.annulation" :required="false"></moment-date-picker>
                                    </div>

                                    <div class="form-group col-md-3">
                                        <label for="annulationReasonInput">{{ $t('partner.form.implication.annulationReason') }}</label>
                                        <select v-model="partner.annulationReason" class="form-control" id="annulationReasonInput" v-bind:placeholder="$t('partner.form.implication.annulationReason')">
                                            <option v-for="s in annulationReasons" :value="s.item1" :key="s.item1">{{s.item2}}</option>
                                        </select>
                                        <span class="text-danger" v-if="errors.has('annulationReason')">{{ errors.first('annulationReason') }}.</span>
                                    </div>
                                 </div>
                            </div>
                        </div>
                    </div>
                </div>

                <create-partner-contact v-if="!coinvestor" :compMode="compMode" :partnerContact="partner.partnerContact"></create-partner-contact>
                
                <view-event-person v-if="compMode == CRUDMODE.READ" :partnerId="partner.id"></view-event-person>

                <a @click="createPartner" v-if="compMode == CRUDMODE.CREATE || compMode == CRUDMODE.COPY" id="addButton" class="btn btn-primary">
                    {{ $t('form.create_button') }}
                </a>

                <a @click="editPartner" v-if="compMode == CRUDMODE.UPDATE" id="editButton" class="btn btn-primary">
                    {{ $t('form.edit_button') }}
                </a>
                
            </form>
        </div>
    </div>
</div>

</template>

<script>
import {PartnerServiceClient, PersonServiceClient, PartnerDto, AddressDto} from '../../shared/service-clients/service-clients'
import ServiceFactory from '../../shared/service-clients/serviceClientFactory'
import ErrorMessage from '../ErrorMessage.vue'
import AddressComponent from '../Address.vue'
import CrudMixin from '../../shared/Mixin/CrudMixin'
import moment from 'moment'
import Enum from '@/shared/enum'
import CreatePartnerContact from './CreatePartnerContact'
import ViewEventPerson from '../events/ViewEventPerson'
import MomentDatePicker from '../../shared/components/MomentDatePicker'
import PhotoUploader from '../../shared/components/PhotoUploader.vue'

export default {
  name: 'CreatePartner',
  mixins: [CrudMixin],
  props: {
    coinvestor: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    let dto = new PartnerDto()
    dto.address = new AddressDto()
    dto.address.init({})
    dto.partnerContact = []

    if (this.coinvestor) dto.plan = 6

    return {
      ready: false,
      error: '',
      partner: dto,
      plans: [],
      annulationReasons: [],
    }
  },
  computed: {
    plan_validate: function() {
      return this.partner.plan == 0 ? null : this.partner.plan
    },
    fileType_partnerLogo: function() {
      return Enum.FileType.PARTNERLOGO
    },
  },
  methods: {
    cleanEntity: function() {
      let cleanPartner = this.cleanFields(this.partner)

      if (cleanPartner.partnerContact == null) {
        cleanPartner.partnerContact = []
      }
      return cleanPartner
    },
    createPartner: function() {
      this.$validator
        .validateAll()
        .then(result => {
          let self = this

          if (result && this.ready) {
            let partnerService = ServiceFactory.create(PartnerServiceClient)

            partnerService
              .create(this.cleanEntity())
              .then(function(res) {
                self.persistFiles(res.id)
                self.$refs.photoUploader.persistPhoto(res.id)
              })
              .then(res => {
                this.$swal('Succès', this.$t('partner.create.succes'), 'success')
                this.$router.push({path: '/partners'})
              })
              .catch(err => {
                self.processError(err, self)
              })
          } else {
            console.log(self.errors)
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
    editPartner: function() {
      this.$validator
        .validateAll()
        .then(result => {
          let self = this

          if (result && this.ready) {
            let partnerService = ServiceFactory.create(PartnerServiceClient)

            partnerService
              .update(this.cleanEntity())
              .then(function(res) {
                self.persistFiles(self.$route.params.id)
                self.$refs.photoUploader.persistPhoto(res.id)
              })
              .then(res => {
                this.$swal('Succès', this.$t('partner.edit.succes'), 'success')
                this.$router.push({path: '/Partners'})
              })
              .catch(err => {
                self.processError(err, self)
              })
          } else {
            console.log(self.errors)
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
    fetchData: function() {
      let partnerService = ServiceFactory.create(PartnerServiceClient)

      let self = this

      let getAnnulationReason = partnerService.getAnnulationReason()
      let getPlan = partnerService.getPlan()

      getAnnulationReason
        .then(res => {
          self.annulationReasons = res
        })
        .catch(err => {
          console.log(err)
        })
      getPlan
        .then(res => {
          self.plans = res
          if (!this.coinvestor) self.plans = _.filter(self.plans, x => x.item1 != 6)
        })
        .catch(err => {
          console.log(err)
        })

      let promisseAll

      if (this.compMode != Enum.Mode.CREATE) {
        let getPartner = partnerService.get(this.$route.params.id)
        getPartner
          .then(res => {
            self.partner = res

            if (self.partner.partnerContact == null) {
              self.partner.partnerContact = []
            }

            self.checkCopyMode(self.partner)
          })
          .catch(err => {
            console.log(err)
          })

        promisseAll = Promise.all([getPlan, getPartner])
      } else {
        promisseAll = Promise.all([getPlan])
      }

      promisseAll.then(v => {
        self.ready = true
      })
    },
  },
  components: {
    errorMessage: ErrorMessage,
    AddressComponent: AddressComponent,
    CreatePartnerContact,
    'moment-date-picker': MomentDatePicker,
    ViewEventPerson,
    'photo-uploader': PhotoUploader,
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
    .btn-primary {
    color: #fff !important;
    cursor: pointer;
    }
</style>



// WEBPACK FOOTER //
// src/components/partners/CreatePartner.vue